import React from "react";
import PdfUploader from "../PdfUploader";

export default function SavingUploadPage() {
  return (
    <div style={{ padding: "20px" }}>
      <PdfUploader />
    </div>
  );
}
